import { render, staticRenderFns } from "./AddFormTemplate.vue?vue&type=template&id=0918a543&scoped=true"
import script from "./AddFormTemplate.vue?vue&type=script&lang=js"
export * from "./AddFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918a543",
  null
  
)

export default component.exports